import * as Icon from "react-feather";
export const expertiseData = [
  {
    title: "Developing",
    Icon: Icon.Monitor,
  },
  {
    title: "Mac OS",
    Icon: Icon.StopCircle,
  },
  {
    title: "Cinema",
    Icon: Icon.Video,
  },
  {
    title: "Coffee",
    Icon: Icon.Coffee,
  },
  {
    title: "Music",
    Icon: Icon.Music,
  },
  {
    title: "Games",
    Icon: Icon.Watch,
  },
  {
    title: "Designing",
    Icon: Icon.Box,
  },
  {
    title: "Sports",
    Icon: Icon.Target,
  },
  {
    title: "Painting",
    Icon: Icon.PenTool,
  },
  {
    title: "Reading",
    Icon: Icon.Book,
  },
  {
    title: "Android",
    Icon: Icon.Smartphone,
  },
  {
    title: "Other Activity",
    Icon: Icon.Activity,
  },
];
export const servicesData = [
  {
    title: "UX / UI Design",
    desc: "The phrasal sequence of the is now so that many campaign and benefit",
    Icon: Icon.Airplay,
  },
  {
    title: "Ios App Designer",
    desc: "The phrasal sequence of the is now so that many campaign and benefit",
    Icon: Icon.Aperture,
  },
  {
    title: "Photography",
    desc: "The phrasal sequence of the is now so that many campaign and benefit",
    Icon: Icon.Camera,
  },
  {
    title: "Graphic Designer",
    desc: "The phrasal sequence of the is now so that many campaign and benefit",
    Icon: Icon.Compass,
  },
  {
    title: "Web Security",
    desc: "The phrasal sequence of the is now so that many campaign and benefit",
    Icon: Icon.Settings,
  },
  {
    title: "Web Security",
    desc: "The phrasal sequence of the is now so that many campaign and benefit",
    Icon: Icon.Watch,
  },
];
export const project = [
  {
    image: "/images/works/1.jpg",
    title: "Fronter Theme",
    subTitle: "UI / UX Design",
  },
  {
    image: "/images/works/2.jpg",
    title: "Fronter Theme",
    subTitle: "UI / UX Design",
  },
  {
    image: "/images/works/3.jpg",
    title: "Fronter Theme",
    subTitle: "UI / UX Design",
  },
  {
    image: "/images/works/4.jpg",
    title: "Fronter Theme",
    subTitle: "UI / UX Design",
  },
  {
    image: "/images/works/5.jpg",
    title: "Fronter Theme",
    subTitle: "UI / UX Design",
  },
  {
    image: "/images/works/6.jpg",
    title: "Fronter Theme",
    subTitle: "UI / UX Design",
  },
  {
    image: "/images/works/7.jpg",
    title: "Fronter Theme",
    subTitle: "UI / UX Design",
  },
  {
    image: "/images/works/8.jpg",
    title: "Fronter Theme",
    subTitle: "UI / UX Design",
  },
];
export const blogData = [
  {
    image: "/images/blog/html1.jpg",
    title: "Tutorial Belajar HTML Part 1",
    desc: "HTML (HyperText Markup Language) adalah bahasa markup yang digunakan untuk membuat dan memformat konten halaman web. HTML terdiri dari..",
    link: "https://medium.com/@RamaFaisal/tutorial-belajar-html-part-1-pengenalan-html-dasar-dasar-html-untuk-pemula-307499967356",
  },
  {
    image: "/images/blog/html2.jpg",
    title: "Tutorial Belajar HTML Part 2",
    desc: "Pada dasarnya, sebuah halaman web dibangun dengan menggunakan berbagai elemen atau “tags” dalam HTML (Hypertext Markup Language). Elemen-elemen ini memberikan..",
    link: "https://medium.com/@RamaFaisal/tutorial-belajar-html-part-2-memahami-element-dalam-html-struktur-dasar-halaman-web-daf99c8dcc68",
  },
  {
    image: "/images/blog/html3.jpg",
    title: "Tutorial Belajar HTML Part 3",
    desc: "Penggunaan Attribute dalam HTML: Menambahkan Informasi Tambahan Dalam HTML (Hypertext Markup Language), attribute (atribut) memainkan peran penting dalam..",
    link: "https://medium.com/@RamaFaisal/tutorial-belajar-html-part-3-penggunaan-attribute-dalam-html-menambahkan-informasi-tambahan-fb1798a469ab",
  },
];
export const review = [
  {
    name: "Michael Kravc",
    designation: "Road to Virtuosity",
    image: "/images/client/ninedragonlabs-michael.jpg",
    desc: "Very professional and well organized. He created a step by step plan in Trello and completed the steps quickly. He has good management and makes quick progress.",
  },
  {
    name: "Michael Thomp",
    designation: "United Kingdom",
    image: "/images/client/michael.jpg",
    desc: "Have strong back-end and dev-ops skills, high quality assurance skills, and detail-oriented person.",
  },
  {
    name: "Judegilbert",
    designation: "Kenya",
    image: "/images/client/jude.jpg",
    desc: "Job done perfectly, couldn't ask for more. They know what they are doing and the fact that they deliver quality work on time is what is needed.",
  },
  {
    name: "Ahmed Samah",
    designation: "Jobsicle",
    image: "/images/client/samah.jpg",
    desc: "Talented and excellent developer in building applications with the latest technology. Also, his communication with clients is very good and always tries to satisfy the needs of clients. I highly recommend him with A++",
  },
  {
    name: "Turai",
    designation: "Agrommunity",
    image: "/images/client/turai.png",
    desc: "Professional work has been done very well. The work is done with great patience so that customer satisfaction is guaranteed. The value of the money spent is very much paid off with very satisfying results.",
  },
];
